import { render } from "./ListeTypeOrganisationPage.vue?vue&type=template&id=0a7310e2&ts=true"
import script from "./ListeTypeOrganisationPage.vue?vue&type=script&lang=ts"
export * from "./ListeTypeOrganisationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__